import * as actionTypes from '../actions/report';

const initialState = {
  reports: [],
  isEventCreateFetching: false,
  loaded: false,
  fetching: false
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REPORTS_BEGIN:
      return {
        ...state,
        fetching: true
      };
    case actionTypes.FETCH_REPORTS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const sortedReports = action.payload.sort((a, b) => b.id - a.id);
      // eslint-disable-next-line no-case-declarations
      const reports = sortedReports.map(report => {
        const reportSerialized = {
          reportFilters: report.data.filters,
          archived: report.data.archived || false,
          ...report
        };
        delete reportSerialized.data;
        return reportSerialized;
      });
      return {
        ...state,
        reports,
        fetching: false,
        loaded: true
      };
    case actionTypes.FETCH_REPORTS_FAILURE:
      return {
        ...state,
        fetching: false
      };
    case actionTypes.CREATE_REPORT_BEGIN:
      return {
        ...state,
        isEventCreateFetching: true
      };
    case actionTypes.CREATE_REPORT_SUCCESS:
      return {
        ...state,
        reports: [action.payload, ...state.reports]
      };
    case actionTypes.CREATE_REPORT_FAILURE:
      return {
        ...state,
        isEventCreateFetching: false
      };
    case actionTypes.UPDATE_REPORT_BEGIN:
      return {
        ...state,
        isEventCreateFetching: true
      };
    case actionTypes.UPDATE_REPORT_SUCCESS:
      return {
        ...state,
        reports: state.reports.map(report => {
          if (report.id === action.payload.id) {
            return action.payload;
          }

          return report;
        })
      };
    case actionTypes.UPDATE_REPORT_FAILURE:
      return {
        ...state,
        isEventCreateFetching: false
      };
    case actionTypes.DELETE_REPORT_BEGIN:
      return {
        ...state
      };
    case actionTypes.DELETE_REPORT_SUCCESS:
      return {
        ...state,
        reports: [...state.reports].filter(
          report => report.id !== action.payload.id
        )
      };
    case actionTypes.DELETE_REPORT_FAILURE:
      return {
        ...state
      };
    default: {
      return state;
    }
  }
};

export default reportReducer;
